import React, { useEffect } from 'react';
import { SiteSettings } from '../types';

interface GlobalAdScriptProps {
    settings: SiteSettings;
}

const GlobalAdScript: React.FC<GlobalAdScriptProps> = ({ settings }) => {
    useEffect(() => {
        if (!settings.scriptAdGlobalCode) return;

        // Container to parse user HTML string
        const container = document.createElement('div');
        container.innerHTML = settings.scriptAdGlobalCode;

        const injectedElements: HTMLElement[] = [];

        // Append all nodes from the parsed HTML to the document head
        Array.from(container.childNodes).forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                const el = node as HTMLElement;
                let newElement: HTMLElement;
                
                if (el.tagName.toLowerCase() === 'script') {
                    // Scripts need to be recreated to execute
                    newElement = document.createElement('script');
                    Array.from(el.attributes).forEach(attr => {
                        newElement.setAttribute(attr.name, attr.value);
                    });
                    newElement.innerHTML = el.innerHTML;
                } else if (el.tagName.toLowerCase() === 'link') {
                    // Links can just be cloned
                    newElement = document.createElement('link');
                    Array.from(el.attributes).forEach(attr => {
                        newElement.setAttribute(attr.name, attr.value);
                    });
                } else {
                    newElement = el.cloneNode(true) as HTMLElement;
                }

                // Add a data attribute to keep track of injected elements
                newElement.setAttribute('data-global-ad-script', 'true');
                document.head.appendChild(newElement);
                injectedElements.push(newElement);
            }
        });

        // Cleanup function to remove injected scripts when settings change or unmount
        return () => {
            injectedElements.forEach(el => {
                if (document.head.contains(el)) {
                    document.head.removeChild(el);
                }
            });
            // Fallback for elements matched by data attribute (in case cleanup array missed it)
            document.querySelectorAll('[data-global-ad-script="true"]').forEach(el => el.remove());
        };
    }, [settings.scriptAdGlobalCode]);

    return null;
};

export default GlobalAdScript;
